window.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.media-video');

  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    const btn = wrapper.querySelector('.media-video__play-btn');
    if (!video || !btn) return;

    video.removeAttribute('controls');

    btn.addEventListener('click', () => {
      video.setAttribute('controls', '');
      video.play();
      btn.hidden = true;
      wrapper.classList.add('is-playing');
    });

    video.addEventListener('ended', () => {
      video.removeAttribute('controls');
      video.currentTime = 0;
      btn.hidden = false;
      wrapper.classList.remove('is-playing');
    });
  });
});
